import { createSharedComposable, useIntervalFn } from '@vueuse/core'
import { DateTime } from 'luxon'
import { ref } from 'vue'

function createToday() {
	const today = ref(DateTime.utc().startOf('day'))

	useIntervalFn(() => {
		const now = DateTime.utc().startOf('day')

		if (now.day !== today.value.day) {
			today.value = now.toUTC()
		}
	}, 60_000)

	return {
		today
	}
}

export const useToday = createSharedComposable(createToday)
